<template>
  <div class="core">
      <div class="layui-fluid">
          <pub-search :search-type="'add'" :tableObj="tableObj" :searchConfig="searchConfig">
          </pub-search>
          <layui-table
            ref="operLogTable"
            table-name="SYS_OPER_LOG"
            :sort="['OPER_MODULE,BUSINESS_TYPE,ORDER_NUM:DESC']"
            :page-size="20"
            :page-range="6"
            :page-options="[10, 20, 50, 100]"
            :skin="'line'"
            :beforeRender="handleBeforeRnder"
            @table-event-detailEdit="detailEdit($event.data)"
            @table-event-detailDel="detailDel($event.data)">
            <div>
                <div checkbox="true" align="center" fixed="left" width="60"></div>
                <layui-tableconfig :config = "tableList"></layui-tableconfig>
                <div rowspan="3" align="center" fixed="right" title="操作" width="130">
                    <script type="text/html" v-pre>
                        {{#  if(d.BUSINESS_TYPE == '2'){ }}
                          <a class="layui-btn-xs" lay-event="detailDel">详情</a>
                        {{#  } }}
                        {{#  if(d.BUSINESS_TYPE == '1'){ }}
                          <a class="layui-btn-xs" lay-event="detailEdit">详情</a>
                        {{#  } }}
                    </script>
                </div>
            </div>
        </layui-table>
      </div>
      <!-- 修改详情 -->
      <div id="edit_detail" class="layui-layer-content" style="display:none;">
        <div class="layui-card-header" style="margin-top: 40px;">修改记录</div>
          <div class="layui-form" style="height: calc(100% - 103px);overflow-y: auto;">
              <ul class="layui-timeline">
                <li class="layui-timeline-item"  v-for="(p, key, i) in editDetailData" :key="i">
                  <i class="layui-icon layui-timeline-axis"></i>
                  <div class="layui-timeline-content layui-text">
                    <h3 class="layui-timeline-title">{{p.update_time}}</h3>
                    <span>修改人：{{p.update_user_name}}</span>
                    <table class="layui-table">
                        <thead>
                          <tr>
                            <td>字段名</td>
                            <td>原值</td>
                            <td>现值</td>
                          </tr>
                        </thead>
                        <tr v-for="(c, j) in editDetailData[key]['content']" :key="j">
                          <td :title="c.field_alias">{{c.field_alias}}</td>
                          <td v-if="c.field == 'NEED_REPAIR_PART'" :title="c.old_value == '1' ? '是' : ''">{{c.old_value == "1" ? "是" : ""}}</td>
                          <td v-if="c.field == 'NEED_REPAIR_PART'" :title="c.new_value == '1' ? '是' : ''">{{c.new_value == "1" ? "是" : ""}}</td>
                          <td v-if="c.field != 'NEED_REPAIR_PART'" :title="c.old_value_desc ? c.old_value_desc : c.old_value">{{c.old_value_desc ? c.old_value_desc : c.old_value}}</td>
                          <td v-if="c.field != 'NEED_REPAIR_PART'" :title="c.new_value_desc ? c.new_value_desc : c.new_value">{{c.new_value_desc ? c.new_value_desc : c.new_value}}</td>
                        </tr>
                    </table>
                  </div>
                </li>
              </ul>  
          </div>
      </div>
  </div>
</template>
<script>
import "../../../utils/map/css/core.css"

export default {
  name: 'operLog',
  data () {
    return {
      tableObj: {
          checkedRows: 0,
          queryObject: {}
      },
        tableList:[
          { field: 'OPER_MODULE_DESC', title: '操作模块'},
          { field: 'BUSINESS_TYPE_DESC', title: '操作类型'},
          { field: 'ORDER_NUM', title: '编号' },
          { field: 'OPER_USER_NAME', title: '最后操作人' },
          { field: 'OPER_TIME', title: '最后操作时间' },
        ],
        searchConfig: {
          basic: [
            { TYPE:'input', WIDTH: 260,  FIELD: 'OPER_USER_NAME:2,ORDER_NUM:2', PLACEHOLDER: '请输入搜索条件'},
          ],
          advanced: [
            { TYPE:'layui-multiselect', NAME: '操作模块:', FIELD: 'OPER_MODULE:1',textField: 'text', valueField: 'value',initData:this.dict.getData('OPER_MODULE'),},
            { TYPE:'layui-multiselect', NAME: '操作类型:', FIELD: 'BUSINESS_TYPE:1',textField: 'text', valueField: 'value',initData:this.dict.getData('BUSINESS_TYPE'),},
            { TYPE:'input', NAME: '编号 :', FIELD:'ORDER_NUM:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '操作人 :', FIELD:'OPER_USER_NAME:2', PLACEHOLDER: '请输入查询条件'},
          ]
        },
        formData: null,
        editDetailData:[],
    }
  },
  mounted() {
    this.tableObj = this.$refs.operLogTable;
    this.tableObj.load();
  },
  methods: {
    handleBeforeRnder(data){
      if(data && data.length > 0) {
        data.forEach((e) => {
          if(e.OPER_MODULE == 1) {
              e.OPER_MODULE_DESC = '客户服务请求';
          } else if(e.OPER_MODULE == 2){
              e.OPER_MODULE_DESC = '现场服务管理';
          }
          if(e.BUSINESS_TYPE == 1){
              e.BUSINESS_TYPE_DESC = '修改';
          } else if(e.BUSINESS_TYPE == 2){
              e.BUSINESS_TYPE_DESC = '删除';
          }
        })
      }
    },
    //删除记录的详情
    detailDel(row){
      if(row.OPER_MODULE == 1){
        var p2 = {};
        p2["WORK_ORDER_ID"] = row["ORDER_ID"];
        var requestId = "queryDetailForDel";
        this.api.queryList(
            'YW_WORK_ORDER_DETAIL_V1',
            {p2: p2},
            requestId
        ).then(response => {
            var result = response.result;
            var data = [];
            data = result[0];
            var p2 = {};
            p2["F_WORK_ORDER_ID"] = row["ORDER_ID"];
            this.api.queryList(
                'YW_SERVICE_ORDER_V1',
                {p2: p2},
                requestId
            ).then(response => {
              var result2 = response.result;
              data["YW_SERVICE_ORDER_V1"] = result2;
              var componentName = 'allForm-' + data["WORK_ORDER_ID"];
              this.baseComponent.smartLoadComponent('allForm', {title: '工单详情-' + data['WORK_ORDER_NUM'], formData: data, from: 'operLog'}, {uniqueName: componentName})
            })
        });
      }else if(row.OPER_MODULE == 2){
         var p2 = {};
        p2["SERVICE_ORDER_NUM"] = row["ORDER_NUM"];
        var requestId = "queryDetailForDel";
        this.api.queryList(
            'YW_SERVICE_ORDER_V1',
            {p2: p2},
            requestId
        ).then(response => {
            var result = response.result;
            var componentName = 'siteForm-' + row["ORDER_NUM"];
            this.baseComponent.smartLoadComponent('siteForm', {title: '详情-' + row['ORDER_NUM'], formData: result[0], from: 'operLog'}, {uniqueName: componentName});
        });
      }
    },
    //修改的详情
    detailEdit(row){
        let popId = 'edit_detail';
        let width = '500px';
        let data = JSON.parse(row["OPER_CONTENT"]);
        this.editDetailData = data.sort((a,b)=>{
          return new Date(b.update_time) - new Date(a.update_time);
        });
        $('.layui-layer-shade').length == 0 ? this.layer.openConfigPopRight({popId: popId, width: width, targetEl: $('.core')}) : ''
    }
  }
}
</script>
<style scoped>
    .core >>> .layui-layer-content{
      overflow-y: hidden;
    }
    #edit_detail{
      background: #fff;
    }
    #edit_detail .layui-table{
      table-layout: fixed;
    }
    #edit_detail thead tr{
      background: #F1F8FB;
    }
    #edit_detail td{
      height: 32px;
      line-height: 32px;
      width: 33.3%;
      text-align: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
</style>


// WEBPACK FOOTER //
// src/components/workOrder/operLog/index.vue